import React from "react";
import DashboardMockup from "@/components/DashboardMockup";
import { Check } from "lucide-react";

const APP_URL = "https://app.fittrackcoach.in";

export default function Hero() {
  return (
    <section id="top" className="relative pt-28 pb-20 md:pt-36 md:pb-28" data-testid="hero-section">
      {/* Background decoration */}
      <div className="absolute inset-0 grid-bg" aria-hidden="true" />
      <div className="hero-glow hero-glow-1" aria-hidden="true" />
      <div className="hero-glow hero-glow-2" aria-hidden="true" />

      <div className="section-container relative">
        <div className="max-w-3xl mx-auto text-center">
          <div className="chip mx-auto mb-6 reveal" data-testid="hero-chip">
            <span className="dot-live" />
            Built for coaches who want to scale, not struggle
          </div>

          <h1
            className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight reveal"
            data-testid="hero-headline"
          >
            Manage Clients.
            <br />
            Track Progress.
            <br />
            <span className="gradient-text">Scale Your Coaching Income.</span>
          </h1>

          <p
            className="mt-6 text-base md:text-lg text-white/65 max-w-2xl mx-auto leading-relaxed reveal"
            data-testid="hero-subheadline"
          >
            FitTrackCoach is the all-in-one platform for personal trainers and fitness coaches to
            manage clients, track progress, and deliver workout &amp; diet plans — all from one
            beautiful dashboard.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4 reveal">
            <a
              href={APP_URL}
              className="btn-primary-glow rounded-xl px-7 py-4 text-base inline-flex items-center gap-2 w-full sm:w-auto justify-center"
              data-testid="hero-cta-primary"
            >
              Start Free — Setup in 2 Minutes
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
              </svg>
            </a>
            <a
              href="#features"
              className="btn-ghost rounded-xl px-7 py-4 text-base w-full sm:w-auto text-center font-semibold"
              data-testid="hero-cta-secondary"
            >
              See how it works
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/50 reveal" data-testid="hero-microcopy">
            <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> Free forever plan</span>
            <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> Setup in under 2 minutes</span>
            <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> Mobile-ready</span>
          </div>
        </div>

        {/* Hero visual */}
        <div className="mt-16 md:mt-20 relative reveal" data-testid="hero-visual">
          <div className="mockup-glow max-w-5xl mx-auto">
            <DashboardMockup />
          </div>
        </div>
      </div>
    </section>
  );
}
